/* @flow */
import React from 'react';
import Activity from 'entities/Activity';
import Money from 'payments/components/Money.jsx';
import Text from 'components/Text.jsx';
import Link from 'components/Link.jsx';
import TimeRange from 'components/TimeRange.jsx';

import './styles/ActivityListMiniItem.scss';

type Props = {
  activity: Activity,
};

class ActivityListMiniItem extends React.Component {
  props: Props;

  renderLastInfoRow() {
    const { activity } = this.props;

    return (
      <Text color="jungle" weight="semibold">
        {(() => {
          if (activity.isFree()) {
            return 'Free';
          } else if (activity.isSender()) {
            return <Money cents={activity.getTotalCollected()} />;
          } else {
            return <Money cents={activity.getAmountPerPerson()} />;
          }
        })()}
      </Text>
    );
  }

  render() {
    const { activity } = this.props;
    const startAt = activity.getStartAt();
    const endAt = activity.getEndAt();

    return (
      <div className="ActivityListMiniItem">
        <div className="ActivityListMiniItem-info">
          <div className="ActivityListMiniItem-info-title">
            <Text truncate>
              {(() => {
                if (activity.isSender()) {
                  return <Link to={`/activities/${activity.id}`}>{activity.getTitle()}</Link>;
                } else {
                  return activity.getTitle();
                }
              })()}
            </Text>
          </div>
          <div className="ActivityListMiniItem-info-item">
            <Text color="thunder">
              Organized by {activity.getRequester().getDisplayName()}
            </Text>
          </div>
          {startAt &&
            <div className="ActivityListMiniItem-info-item">
              <Text color="thunder">
                <TimeRange
                  start={startAt}
                  end={endAt}
                  month="long"
                  year="numeric"
                  day="numeric"
                  hour="numeric"
                  minute="numeric"
                />
              </Text>
            </div>
          }
          <div className="ActivityListMiniItem-info-item">
            {this.renderLastInfoRow()}
          </div>
        </div>
      </div>
    );
  }
}

export default ActivityListMiniItem;



// WEBPACK FOOTER //
// ./src/payments/components/ActivityListMiniItem.jsx